/*
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */
import React, { lazy, Suspense, useState, useEffect, useCallback } from "react";
import { Container, Row, Col, Image, Button, Modal } from "react-bootstrap";
import htmlParser from "html-react-parser";
import { formatInTimeZone } from "date-fns-tz";
import "../Body/Body.css";

import RigVedQuotes from "../RigvedQuotes/index";

export default function Body(props) {
  const imgCDNURL = process.env.REACT_APP_PARTNERSERVICE_CDN_URL;
  const [showRigVedQuotes, setShowRigVedQuotes] = useState(false);

  function scrollToSection1() {
    const sectionPosition = document.getElementById("contactusform").offsetTop;
    window.scrollTo({
      top: sectionPosition,
      behavior: "smooth",
    });
  }
  function scrollToSection2() {
    const sectionPosition = document.getElementById("contactusform1").offsetTop;
    window.scrollTo({
      top: sectionPosition,
      behavior: "smooth",
    });
  }
  return (
    <>
      <div className="banner">
        <Container>
          <Row className="joaquinrow">
            <Col sm={12} md={12} xl={8} lg={8}>
              <div className="breakingbarrirests">
                <p className="partneringtext">Partnering for Prosperity:</p>
                <p className="breaktxt">
                  Explore Success Beyond Boundaries with Sun West
                </p>
                <div className="brandTagLineContainerDesktop">
                  <p
                    className="clalfatextspan"
                    onClick={() => {
                      setShowRigVedQuotes(true);
                    }}
                    onMouseOver={() => {
                      setShowRigVedQuotes(true);
                    }}
                    onMouseOut={() => {
                      setShowRigVedQuotes(false);
                    }}
                    aria-label="Brand Tag Line"
                  >
                    Nothing Is Beyond Reach<sup>TM</sup>
                    {/* {aiBrandingData ? parser(aiBrandingData.current.brandTagLine ? aiBrandingData.current.brandTagLine : "") : ""} */}
                  </p>
                  <RigVedQuotes showRigVedQuotes={showRigVedQuotes} />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
